exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width:768px){.card-body[data-v-49f64e66]{min-height:160px}}@media (max-width:992px){.addon-ticket-selection[data-v-49f64e66]{margin-bottom:1rem}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-49f64e66","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/tickets/AddonTickets.vue
// module id = qfIo
// module chunks = 0